import React from 'react';
import { Shield } from 'lucide-react';
export function TypingIndicator() {
  return <div className="flex items-end space-x-2 mb-4 animate-fade-in" data-id="element-75">
      {/* Bot Avatar */}
      <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full flex items-center justify-center bg-primary-100 text-primary-700 border border-primary-200 shadow-sm mb-1" data-id="element-76">
        <Shield className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-77" />
      </div>

      {/* Typing Bubble */}
      <div className="bg-white border border-slate-200 px-4 py-3 rounded-2xl rounded-bl-none shadow-sm flex items-center space-x-1.5 h-10 sm:h-12" data-id="element-78">
        <div className="w-2 h-2 bg-slate-400 rounded-full animate-bounce" style={{
        animationDelay: '0ms'
      }} data-id="element-79" />
        <div className="w-2 h-2 bg-slate-400 rounded-full animate-bounce" style={{
        animationDelay: '150ms'
      }} data-id="element-80" />
        <div className="w-2 h-2 bg-slate-400 rounded-full animate-bounce" style={{
        animationDelay: '300ms'
      }} data-id="element-81" />
      </div>

      <span className="text-xs text-slate-400 pb-2 animate-pulse" data-id="element-82">
        Typing...
      </span>
    </div>;
}